export const features = [
  { name: "trends", isActive: false },
  { name: "scope-hierarchy", isActive: false, isOpenForDemo: false },
  { name: "old-scope", isActive: true, isOpenForDemo: true },
  { name: "category-trends", isActive: false, isOpenForDemo: false },
];
